import React from 'react'
import { Link } from 'react-router-dom'

import client1 from '../assets/images/client/01.jpg'
import client2 from '../assets/images/client/02.jpg'
import client3 from '../assets/images/client/03.jpg'

export default function BlogComments() {
  return (
    <div className="mt-4 pt-2">
        <div className="card rounded-0 border-0">
            <h4 className="heading-title mb-0">Comments</h4>

            <ul className="media-list list-unstyled mt-4 pt-2 mb-0">
                <li className="comment-desk">
                    <div className="commentor d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                            <Link className="pe-3" to="#">
                                <img src={client1} className="img-fluid avatar avatar-ex-sm rounded-circle shadow" alt=""/>
                            </Link>
                            <div className="commentor-detail">
                                <h6 className="mb-0"><Link to="#" className="text-dark media-heading">Lorenzo Peterson</Link></h6>
                                <small className="text-muted">13th March 2024 at 01:25 pm</small>
                            </div>
                        </div>
                        <Link to="#" className="text-muted"><i className="mdi mdi-reply"></i> Reply</Link>
                    </div>
                    <div className="mt-3">
                        <p className="text-muted fst-italic p-3 bg-light rounded shadow">" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "</p>
                    </div>
                </li>

                <li className="mt-4 comment-desk">
                    <div className="commentor d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                            <Link className="pe-3" to="#">
                                <img src={client2} className="img-fluid avatar avatar-ex-sm rounded-circle shadow" alt=""/>
                            </Link>
                            <div className="commentor-detail">
                                <h6 className="mb-0"><Link to="#" className="media-heading text-dark">Tammy Camacho</Link></h6>
                                <small className="text-muted">5th May 2023 at 10:00 am</small>
                            </div>
                        </div>
                        <Link to="#" className="text-muted"><i className="mdi mdi-reply"></i> Reply</Link>
                    </div>
                    <div className="mt-3">
                        <p className="text-muted fst-italic p-3 bg-light rounded shadow">" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "</p>
                    </div>
                </li>
                
                <li className="mt-4 comment-desk">
                    <div className="commentor d-flex justify-content-between">
                        <div className="d-flex align-items-center">
                            <Link className="pe-3" to="#">
                                <img src={client3} className="img-fluid avatar avatar-ex-sm rounded-circle shadow" alt=""/>
                            </Link>
                            <div className="commentor-detail">
                                <h6 className="mb-0"><Link to="#" className="media-heading text-dark">Tammy Camacho</Link></h6>
                                <small className="text-muted">19th June 2023 at 09:00 am</small>
                            </div>
                        </div>
                        <Link to="#" className="text-muted"><i className="mdi mdi-reply"></i> Reply</Link>
                    </div>
                    <div className="mt-3">
                        <p className="text-muted fst-italic p-3 bg-light rounded shadow">" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "</p>
                    </div>

                    <ul className="list-unstyled ps-4 ps-md-5 sub-comment">
                        <li className="mt-4 comment-desk">
                            <div className="commentor d-flex justify-content-between">
                                <div className="d-flex align-items-center">
                                    <Link className="pe-3" to="#">
                                        <img src={client1} className="img-fluid avatar avatar-ex-sm rounded-circle shadow" alt=""/>
                                    </Link>
                                    <div className="commentor-detail">
                                        <h6 className="mb-0"><Link to="#" className="text-dark media-heading">Lorenzo Peterson</Link></h6>
                                        <small className="text-muted">20th June 2023 at 01:25 pm</small>
                                    </div>
                                </div>
                                <Link to="#" className="text-muted"><i className="mdi mdi-reply"></i> Reply</Link>
                            </div>
                            <div className="mt-3">
                                <p className="text-muted fst-italic p-3 bg-light rounded shadow">" There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour "</p>
                            </div>
                        </li>
                    </ul>
                </li>
            </ul>

            <form className="mt-4 pt-2">
                <div className="row">
                    <div className="col-md-12">
                        <div className="mb-3">
                            <label className="form-label">Your Comment</label>
                            <textarea id="message" placeholder="Your Comment" rows="5" name="message" className="form-control" required=""></textarea>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label className="form-label">Name <span className="text-danger">*</span></label>
                            <input id="name" name="name" type="text" placeholder="Name" className="form-control" required=""/>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="mb-3">
                            <label className="form-label">Your Email <span className="text-danger">*</span></label>
                            <input id="email" type="email" placeholder="Email" name="email" className="form-control" required=""/>
                        </div>
                    </div>

                    <div className="col-md-12">
                        <div className="send d-grid">
                            <button type="submit" className="btn btn-primary">Send Message</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
  )
}
